import type { OrgMemberRole, Permission } from "../types.js";

/**
 * Org role → permission set for UI gating. Mirrors @app/core
 * ORG_ROLE_PERMISSIONS. The API is authoritative (authorizeOrg); this only
 * decides which controls to SHOW, so a self-service org admin — who holds no
 * GLOBAL permissions — still sees the controls their org role grants.
 */
const ORG_ROLE_PERMISSIONS: Record<OrgMemberRole, readonly Permission[]> = {
  admin: [
    "product:read",
    "product:write",
    "passport:read",
    "passport:write",
    "passport:publish",
    "org:read",
    "import:run",
    "supplier:manage",
    "access:manage",
    "integration:manage",
  ],
  editor: [
    "product:read",
    "product:write",
    "passport:read",
    "passport:write",
    "import:run",
    "supplier:manage",
    "org:read",
  ],
  viewer: ["product:read", "passport:read", "org:read"],
};

/** Effective org permissions for a role (empty for null — no active org / not a member). */
export function orgRolePermissions(role: OrgMemberRole | null | undefined): ReadonlySet<Permission> {
  return new Set(role ? ORG_ROLE_PERMISSIONS[role] : []);
}
